import { gql } from "@apollo/client";

export const GET_API_KEYS_MANAGEABLE_BY_NON_HUMANS = gql`
  query GetApiKeysManageableByNonHumans {
    apiKeysManageableByNonHumans
  }
`;

export const TOGGLE_API_KEYS_MANAGEABLE_BY_NON_HUMANS = gql`
  mutation ToggleAPIKeyManagementFromNonHumans {
    accountToggleAPIKeyManagementFromNonHumans
  }
`;